import React from "react";
import { Link } from "../../../utils/customLink";
import {
  getCDNProviderToUse,
  getSourceImageUrlToCGI
} from "../../../utils/base";
import Image from "../../../components/image";

import ArrowRightIcon from "../../../images/icons/arrow-right-icon.inline.svg";

export const IssueSlide = ({ index, slideData }) => {
  const { title, subtitle, content, images, bg_image, cta_title, cta_url } =
    slideData;

  const image1 =
    images[0]?.gatsbyImage ??
    getCDNProviderToUse({ width: 500, uri: images[0]?.sourceUrl });
  const image2 =
    images[1]?.gatsbyImage ??
    getCDNProviderToUse({ width: 500, uri: images[1]?.sourceUrl });
  const image3 =
    images[2]?.gatsbyImage ??
    getCDNProviderToUse({ width: 500, uri: images[2]?.sourceUrl });
  const slideBGImage =
    bg_image ??
    getSourceImageUrlToCGI({ uri: bg_image?.localFile?.publicURL }) ??
    getSourceImageUrlToCGI({ uri: bg_image?.sourceUrl });
  const formattedSubTitle = subtitle?.split(":");

  return (
    <div
      key={`issue-slider-${index}`}
      className={`w-full bg-cover bg-center bg-no-repeat ${
        slideBGImage ? "px-4 sm:px-0" : ""
      }`}
      style={{
        backgroundImage: `${slideBGImage ? `url(${slideBGImage})` : "none"}`
      }}
    >
      <div className="w-full md:w-10/12 md:flex mx-auto md:pt-11 md:pb-28 chama pb-20">
        <div className="w-full md:w-[72%] relative grid gap-0 sm:gap-3 grid-cols-8 grid-rows-5 sm:p-5">
          <div className="col-start-1 col-span-6 md:col-span-4 row-span-full row-start-1 flex py-5 sm:py-14">
            <Image
              imageAlt={""}
              image={image1}
              imageClass="w-full h-full rounded-xs object-cover object-center"
              sourceUrl={image1}
            />
          </div>
          <div
            className={
              "hidden sm:block row-start-2 row-span-2 col-start-5 col-span-3 max-h-64"
            }
          >
            <Image
              imageAlt={""}
              image={image2}
              imageClass="hidden md:block rounded-xs bg-transparent object-cover object-center h-full w-full"
              sourceUrl={image2}
            />
          </div>
          <div
            className={
              "row-start-3 col-start-5 row-span-full sm:row-start-4 sm:row-span-2 sm:col-start-5 col-span-full w-full sm:max-h-64"
            }
          >
            <Image
              imageAlt={""}
              image={image3}
              imageClass="w-full rounded-xs bg-transparent bg-cover bg-center h-full object-cover object-center"
              sourceUrl={image3}
            />
          </div>
        </div>
        <div className="w-full md:w-5/12 md:pl-20 pt-12 md:pt-28">
          <h1
            className="font-light !text-black-lighter dark:!text-white leading-9"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {formattedSubTitle && formattedSubTitle.length > 0 && (
            <p className="h7 py-2 md:pt-8 md:pb-6 font-medium uppercase text-black-lighter dark:text-white">
              <span className="text-gray-generic">
                {`${
                  formattedSubTitle.length > 1
                    ? `${formattedSubTitle[0]} : `
                    : formattedSubTitle[0]
                } `}
              </span>
              {formattedSubTitle[1]}
            </p>
          )}
          <div
            className="text-mob md:text-base text-black-lighter dark:text-gray-generic"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {cta_title && cta_url && (
            <Link
              to={cta_url}
              className={`view-program-link relative w-1/2 z-10 flex flex-row items-center justify-center 
                px-2 py-2 mt-10 text-sm border rounded-full dark:rounded-sm
                text-black-lighter dark:text-white  
                hover:text-white dark:hover:text-gray-darker
                border-generic-text dark:border-white 
                hover:bg-black-lighter dark:hover:bg-white`}
            >
              <p
                className="text-[16px] leading-genericCta font-bold pr-2"
                dangerouslySetInnerHTML={{ __html: cta_title }}
              />
              <ArrowRightIcon className="stroke-white" />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
